@if (initialized) {
  <div class="row">
    <div>&nbsp;</div>
    <div class="icons">
      <button mat-icon-button [disabled]="!('create' | able: newMaterial)" (click)="openMaterialEdit(newMaterial)"
        title="Add material" color="accent">
        <mat-icon>add</mat-icon>
      </button>
    </div>
  </div>
  @if (!materials.length) {
    <div class="mat-body-strong">
      Found no materials for this project.
      @if (('create' | able: newMaterial)) {
        <a class="mat-inline-button" color="accent"
          (click)="openMaterialEdit(newMaterial)" aria-label="Add material" title="Add material">Add material?
        </a>
      }
    </div>
  }
  <!-- list -->
  <div class="list">
    @for (material of materials; track material) {
      <div class="list-card">
        <!-- actions -->
        <div class="hover-icons">
          <a mat-mini-fab [disabled]="!('update' | able: material)" (click)="openMaterialEdit(material)" color="accent"
            aria-label="Edit {{material.name}}" title="Edit {{material.name}}">
            <mat-icon>edit</mat-icon>
          </a>
          <button mat-mini-fab [disabled]="!('delete' | able: material)" (click)="delete(material)" color="warn"
            aria-label="Delete {{material.name}}" title="Delete {{material.name}}">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
        <!-- /actions -->
        <div class="body">
          <div class="mat-headline-6 row">
            <div class="mat-body-strong">
              {{material.name}}
              <span class="mat-caption">({{material.uom}})</span>
            </div>
            <div>
              <div class="mat-body-strong v-center">
                Received: &nbsp;
                @if (material?.track_received) {
                  <mat-icon style="color: green">check</mat-icon>
                }
                @if (!material?.track_received) {
                  <mat-icon>block</mat-icon>
                }
              </div>
              <div class="mat-body-strong v-center">
                Used: &nbsp;
                @if (material?.track_used) {
                  <mat-icon style="color: green">check</mat-icon>
                }
                @if (!material?.track_used) {
                  <mat-icon>block</mat-icon>
                }
              </div>
            </div>
            <div>
              <div>
                <span class="mat-body-strong">Bid items: </span>
                @if (!material?.bid_items?.length) {
                  None
                }
              </div>
              @if (material?.bid_items?.length) {
                <div>
                  @for (bidItem of material?.bid_items; track bidItem) {
                    <div>{{bidItem.item}}</div>
                  }
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    }
  </div>
  <!-- ./list -->
  @if (initialized && pagination.length && materials.length) {
    <mat-paginator (page)="pageChanged($event)"
      [length]="pagination.length" [pageIndex]="pagination.pageIndex" [pageSize]="pagination.pageSize">
    </mat-paginator>
  }
}